/* eslint-disable @typescript-eslint/no-explicit-any */

import { api, ApiResponse } from '@/api/api';
import { INDUSTRY_URLS } from '@/api/url';
import { isAxiosError } from 'axios';

export const apiGetIndustries = async (): Promise<ApiResponse<Industry[]>> => {
  try {
    const response = await api.get<ApiResponse<Industry[]>>(INDUSTRY_URLS.GET);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};
